/**
 * The chart's rendered SVG, for the PDF export.
 *
 * Taken from the DOM rather than rebuilt so the PDF matches what the user is looking at,
 * including whatever they toggled off in the legend. Highcharts renders one SVG per chart
 * container; the explorer shows one chart at a time.
 */
export const captureChartSvg = (container: HTMLElement | null): string | null => {
  const svg = container?.querySelector(".highcharts-container svg");
  if (!svg) {
    return null;
  }
  const clone = svg.cloneNode(true) as SVGElement;
  // A detached SVG carries no stylesheet, so the namespace has to be explicit for it to
  // parse as SVG on the server.
  clone.setAttribute("xmlns", "http://www.w3.org/2000/svg");
  return new XMLSerializer().serializeToString(clone);
};
